import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { ButtonGroupComponent } from './button-group/button-group.component';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { PinButtonComponent } from './pin-button/pin-button.component';
import { IconModule } from '../icon/icon.module';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  imports: [CommonModule, IconModule, MaterialModule],
  declarations: [ButtonComponent, ButtonGroupComponent, ButtonIconComponent, PinButtonComponent],
  exports: [ButtonComponent, ButtonGroupComponent, ButtonIconComponent, PinButtonComponent],
})
export class ButtonsModule {}
